module.exports = __webpack_public_path__ + "static/media/Greydwarf_eye.b7657a29.png";